<template>
  <div class="">
    <div class="">
      <div class="dialog-header">
        <div class="image">
          <icon :type="'details'" />
        </div>
        <h1>Start Year</h1>
      </div>

      <div class="container-fluid data-container mw-1940">
        <main class="bd-main">
          <div class="row">
            <div class="col-12">
              <div class="d-none d-lg-block">
                <div class="vertical-flex">
                  <p class="mt-3">
                    Once you have your forecasts set up for your expense drivers and are happy with your forecast targets, click 'Start Year' to begin tracking your monthly performance against your targets.
                  </p>
                  <img src="@/assets/images/profit-loss.png" alt="Start Year Button" class="img-fluid form-center" />
                  <p class="mt-5">
                    For more information about profit and loss and how to use Sinchii, click <a href="https://sinchii.com.au/resources/" target="_blank">here</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="mb-4">
      <div class="row justify-content-center pt-5">
        <div class="col-12 col-lg-5 text-center">
          <k-button class="btn btn-lg btn-secondary w-100" type="button" @click="close">Let's Begin</k-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "../Icon.vue";

export default {
  components: {
    icon
  },
  methods: {
    close() {
      this.$emit("onClose");
    }
  }
};

</script>
